import './index.css';var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import require$$0, { createContext, useContext, useState, useMemo, useCallback, useRef, useEffect, PureComponent } from "react";
import { useAsyncFn, useCarousel } from "@sb/ui/lib";
import { Button, ButtonClean, Alert, Skeleton, TabsRoot, TabsList, TabsTrigger } from "@sb/ui/components";
import { useBetslipSelectionManager } from "@sb/betslip-react";
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
const root = "sb-banners-root__0UQ86";
const carousel = "sb-banners-carousel__HEE06";
const container$2 = "sb-banners-container__z7gYQ";
const classes$7 = {
  root,
  carousel,
  container: container$2
};
async function fetchBannerEntries(config, {
  abortSignal
}) {
  const url = `${config.baseUrl}/entries?locale=${config.locale}&query[composite_key]=${config.environment}-${config.key}`;
  const response = await fetch(url, {
    headers: {
      api_key: config.apiKey,
      access_token: config.deliveryToken
    },
    signal: abortSignal
  });
  if (!response.ok) {
    throw new Error(`Error fetching banners: ${JSON.stringify(response)}`);
  }
  const data = await response.json();
  return data.entries;
}
function filterBanners(banners) {
  return banners.filter((banner) => {
    if (!banner.enabled) {
      return false;
    }
    const now = /* @__PURE__ */ new Date();
    const startDate = banner.schedule.start_date ? new Date(banner.schedule.start_date) : null;
    const endDate = banner.schedule.end_date ? new Date(banner.schedule.end_date) : null;
    const startDateMet = !startDate || now >= startDate;
    const endDateMet = banner.schedule.no_expiry || !endDate || now <= endDate;
    const daysOfWeekMet = banner.schedule.schedule_type === "daily" || banner.schedule.custom_schedule_days.includes(now.toLocaleString("en-US", {
      weekday: "short"
    }));
    const timeRangeMet = (() => {
      var _a, _b;
      if (!banner.schedule.time_ranges_enabled) {
        return true;
      }
      const londonFormatter = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Europe/London",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      });
      const currentTimeParts = londonFormatter.formatToParts(now);
      const currentHour = Number((_a = currentTimeParts.find((p) => p.type === "hour")) == null ? void 0 : _a.value);
      const currentMinute = Number((_b = currentTimeParts.find((p) => p.type === "minute")) == null ? void 0 : _b.value);
      return banner.schedule.time_ranges.some((range) => {
        const [startHour, startMinute] = range.start_time.split(":").map(Number);
        const [endHour, endMinute] = range.end_time.split(":").map(Number);
        const currentTimeInMinutes = currentHour * 60 + currentMinute;
        const startTimeInMinutes = startHour * 60 + startMinute;
        const endTimeInMinutes = endHour * 60 + endMinute;
        return currentTimeInMinutes >= startTimeInMinutes && currentTimeInMinutes <= endTimeInMinutes;
      });
    })();
    return startDateMet && endDateMet && daysOfWeekMet && timeRangeMet;
  });
}
const slide = "sb-banners-slide__FwCWC";
const action = "sb-banners-action__8hwCu";
const classes$6 = {
  slide,
  action
};
const terms = "sb-banners-terms__bltT4";
const classes$5 = {
  terms
};
const defaultTranslations = {
  terms: {
    buttonLabel: "Terms"
  },
  betslip: {
    add: {
      loading: "Adding to Betslip...",
      success: "Added to Betslip",
      error: "Adding to Betslip has failed",
      alreadyAdded: "This offer is already in your Betslip"
    }
  }
};
const TranslationsContext = /* @__PURE__ */ createContext(defaultTranslations);
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = require$$0, g = 60103;
  reactJsxRuntime_production_min.Fragment = 60107;
  if ("function" === typeof Symbol && Symbol.for) {
    var h = Symbol.for;
    g = h("react.element");
    reactJsxRuntime_production_min.Fragment = h("react.fragment");
  }
  var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for (b in a) n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: g, type: c, key: e, ref: l, props: d, _owner: m.current };
  }
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  hasRequiredJsxRuntime = 1;
  {
    jsxRuntime.exports = requireReactJsxRuntime_production_min();
  }
  return jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
function TermsLink({
  url,
  visible: visible2
}) {
  const translations = useContext(TranslationsContext);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Button,
    {
      className: clsx(classes$5.terms, "banners-carousel__link"),
      size: "small",
      variant: "primary",
      asChild: true,
      tabIndex: visible2 ? 0 : -1,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", {
        // `non-route` is trafalgar way of setting target=_blank
        className: "non-route",
        href: url,
        target: "_blank",
        rel: "noopener",
        children: translations.terms.buttonLabel
      })
    }
  );
}
const alert = "sb-banners-alert__61aMw";
const classes$4 = {
  alert
};
const picture = "sb-banners-picture__-a0jB";
const img = "sb-banners-img__y-NDI";
const placeholder$1 = "sb-banners-placeholder__Mg3Wi";
const classes$3 = {
  picture,
  img,
  placeholder: placeholder$1
};
function SlideContent({
  banner
}) {
  var _a;
  const [loaded, setLoaded] = useState(false);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsxs("picture", {
      className: classes$3.picture,
      children: [banner.background.desktop_image != null && /* @__PURE__ */ jsxRuntimeExports.jsx("source", {
        srcSet: banner.background.desktop_image.url,
        media: "(min-width: 37.5rem)"
      }), /* @__PURE__ */ jsxRuntimeExports.jsx("img", {
        src: (_a = banner.background.mobile_image) == null ? void 0 : _a.url,
        alt: banner.background.alt_text ?? banner.name,
        onLoad: () => {
          setLoaded(true);
        },
        loading: "lazy",
        className: classes$3.img
      })]
    }), !loaded && /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: classes$3.placeholder,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        children: banner.background.alt_text ?? banner.name
      })
    })]
  });
}
function BetslipSlide({
  banner,
  index,
  visible: visible2,
  emblaApi
}) {
  const translations = useContext(TranslationsContext);
  const [isHovered, setIsHovered] = useState(false);
  const {
    toggle,
    isAdded,
    isAdding
  } = useBetslipSelectionManager(banner.bet_slip.selection.selection_id, useMemo(() => ({
    analytics: {
      BetListName: ["Banner"],
      BetListPosition: index
    },
    throwOnError: true
  }), [index]));
  const [onClick, status] = useAsyncFn(useCallback(() => {
    var _a;
    if (isAdded) {
      return Promise.reject(new Error("Selection is already present in Betslip"));
    }
    (_a = emblaApi == null ? void 0 : emblaApi.plugins()) == null ? void 0 : _a.autoplay.stop();
    return toggle().finally(() => {
      var _a2;
      if (!isHovered) {
        (_a2 = emblaApi == null ? void 0 : emblaApi.plugins()) == null ? void 0 : _a2.autoplay.play();
      }
    });
  }, [toggle, isAdded, emblaApi, isHovered]), useMemo(() => ({
    successTTL: 4e3,
    errorTTL: 4e3
  }), []));
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    ButtonClean,
    {
      className: clsx(classes$6.action, "banners-carousel__link"),
      onClick,
      tabIndex: visible2 ? 0 : -1,
      onPointerEnter: () => setIsHovered(true),
      onPointerLeave: () => setIsHovered(false),
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SlideContent, {
        banner
      }), status === "loading" && isAdding && /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
        className: classes$4.alert,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, {
          variant: "info",
          children: translations.betslip.add.loading
        })
      }), status === "success" && isAdded && /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
        className: classes$4.alert,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, {
          variant: "success",
          children: translations.betslip.add.success
        })
      }), status === "error" && !isAdded && /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
        className: classes$4.alert,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, {
          variant: "error",
          children: translations.betslip.add.error
        })
      }), status === "error" && isAdded && /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
        className: classes$4.alert,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, {
          variant: "info",
          children: translations.betslip.add.alreadyAdded
        })
      })]
    }
  );
}
function LinkSlide({
  banner,
  visible: visible2
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("a", {
    href: banner.background.click_url,
    tabIndex: visible2 ? 0 : -1,
    className: clsx(
      classes$6.action,
      // `non-route` is trafalgar way of setting target=_blank
      banner.background.click_target === "new_tab" && "non-route"
    ),
    target: banner.background.click_target === "new_tab" ? "_blank" : "_self",
    rel: "noopener",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(SlideContent, {
      banner
    })
  });
}
function Slide({
  banner,
  index,
  visible: visible2,
  emblaApi
}) {
  const SlideStrategy = useMemo(() => {
    var _a, _b;
    if ((_b = (_a = banner.bet_slip) == null ? void 0 : _a.selection) == null ? void 0 : _b.selection_id) {
      return BetslipSlide;
    }
    return LinkSlide;
  }, [banner]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
    className: clsx("sb-banners-slide", classes$6.slide),
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SlideStrategy, {
      banner,
      visible: visible2,
      index,
      emblaApi
    }), !!banner.terms_url && /* @__PURE__ */ jsxRuntimeExports.jsx(TermsLink, {
      url: banner.terms_url,
      visible: visible2
    })]
  });
}
const defaultOptions = {
  active: true,
  breakpoints: {},
  delay: 4e3,
  jump: false,
  playOnInit: true,
  stopOnFocusIn: true,
  stopOnInteraction: true,
  stopOnMouseEnter: false,
  stopOnLastSnap: false,
  rootNode: null
};
function normalizeDelay(emblaApi, delay) {
  const scrollSnaps = emblaApi.scrollSnapList();
  if (typeof delay === "number") {
    return scrollSnaps.map(() => delay);
  }
  return delay(scrollSnaps, emblaApi);
}
function getAutoplayRootNode(emblaApi, rootNode) {
  const emblaRootNode = emblaApi.rootNode();
  return rootNode && rootNode(emblaRootNode) || emblaRootNode;
}
function Autoplay(userOptions = {}) {
  let options;
  let emblaApi;
  let destroyed;
  let delay;
  let timerStartTime = null;
  let timerId = 0;
  let autoplayActive = false;
  let mouseIsOver = false;
  let playOnDocumentVisible = false;
  let jump = false;
  function init(emblaApiInstance, optionsHandler) {
    emblaApi = emblaApiInstance;
    const {
      mergeOptions,
      optionsAtMedia
    } = optionsHandler;
    const optionsBase = mergeOptions(defaultOptions, Autoplay.globalOptions);
    const allOptions = mergeOptions(optionsBase, userOptions);
    options = optionsAtMedia(allOptions);
    if (emblaApi.scrollSnapList().length <= 1) return;
    jump = options.jump;
    destroyed = false;
    delay = normalizeDelay(emblaApi, options.delay);
    const {
      eventStore,
      ownerDocument
    } = emblaApi.internalEngine();
    const isDraggable = !!emblaApi.internalEngine().options.watchDrag;
    const root2 = getAutoplayRootNode(emblaApi, options.rootNode);
    eventStore.add(ownerDocument, "visibilitychange", visibilityChange);
    if (isDraggable) {
      emblaApi.on("pointerDown", pointerDown);
    }
    if (isDraggable && !options.stopOnInteraction) {
      emblaApi.on("pointerUp", pointerUp);
    }
    if (options.stopOnMouseEnter) {
      eventStore.add(root2, "mouseenter", mouseEnter);
    }
    if (options.stopOnMouseEnter && !options.stopOnInteraction) {
      eventStore.add(root2, "mouseleave", mouseLeave);
    }
    if (options.stopOnFocusIn) {
      emblaApi.on("slideFocusStart", stopAutoplay);
    }
    if (options.stopOnFocusIn && !options.stopOnInteraction) {
      eventStore.add(emblaApi.containerNode(), "focusout", startAutoplay);
    }
    if (options.playOnInit) startAutoplay();
  }
  function destroy() {
    emblaApi.off("pointerDown", pointerDown).off("pointerUp", pointerUp).off("slideFocusStart", stopAutoplay);
    stopAutoplay();
    destroyed = true;
    autoplayActive = false;
  }
  function setTimer() {
    const {
      ownerWindow
    } = emblaApi.internalEngine();
    ownerWindow.clearTimeout(timerId);
    timerId = ownerWindow.setTimeout(next, delay[emblaApi.selectedScrollSnap()]);
    timerStartTime = (/* @__PURE__ */ new Date()).getTime();
    emblaApi.emit("autoplay:timerset");
  }
  function clearTimer() {
    const {
      ownerWindow
    } = emblaApi.internalEngine();
    ownerWindow.clearTimeout(timerId);
    timerId = 0;
    timerStartTime = null;
    emblaApi.emit("autoplay:timerstopped");
  }
  function startAutoplay() {
    if (destroyed) return;
    if (documentIsHidden()) {
      playOnDocumentVisible = true;
      return;
    }
    if (!autoplayActive) emblaApi.emit("autoplay:play");
    setTimer();
    autoplayActive = true;
  }
  function stopAutoplay() {
    if (destroyed) return;
    if (autoplayActive) emblaApi.emit("autoplay:stop");
    clearTimer();
    autoplayActive = false;
  }
  function visibilityChange() {
    if (documentIsHidden()) {
      playOnDocumentVisible = autoplayActive;
      return stopAutoplay();
    }
    if (playOnDocumentVisible) startAutoplay();
  }
  function documentIsHidden() {
    const {
      ownerDocument
    } = emblaApi.internalEngine();
    return ownerDocument.visibilityState === "hidden";
  }
  function pointerDown() {
    if (!mouseIsOver) stopAutoplay();
  }
  function pointerUp() {
    if (!mouseIsOver) startAutoplay();
  }
  function mouseEnter() {
    mouseIsOver = true;
    stopAutoplay();
  }
  function mouseLeave() {
    mouseIsOver = false;
    startAutoplay();
  }
  function play(jumpOverride) {
    if (typeof jumpOverride !== "undefined") jump = jumpOverride;
    startAutoplay();
  }
  function stop() {
    if (autoplayActive) stopAutoplay();
  }
  function reset() {
    if (autoplayActive) startAutoplay();
  }
  function isPlaying() {
    return autoplayActive;
  }
  function next() {
    const {
      index
    } = emblaApi.internalEngine();
    const nextIndex = index.clone().add(1).get();
    const lastIndex = emblaApi.scrollSnapList().length - 1;
    const kill = options.stopOnLastSnap && nextIndex === lastIndex;
    if (emblaApi.canScrollNext()) {
      emblaApi.scrollNext(jump);
    } else {
      emblaApi.scrollTo(0, jump);
    }
    emblaApi.emit("autoplay:select");
    if (kill) return stopAutoplay();
    startAutoplay();
  }
  function timeUntilNext() {
    if (!timerStartTime) return null;
    const currentDelay = delay[emblaApi.selectedScrollSnap()];
    const timePastSinceStart = (/* @__PURE__ */ new Date()).getTime() - timerStartTime;
    return currentDelay - timePastSinceStart;
  }
  const self = {
    name: "autoplay",
    options: userOptions,
    init,
    destroy,
    play,
    stop,
    reset,
    isPlaying,
    timeUntilNext
  };
  return self;
}
Autoplay.globalOptions = void 0;
const container$1 = "sb-banners-container__eFeNr";
const visible = "sb-banners-visible__LtGNM";
const bar = "sb-banners-bar__VMkZA";
const classes$2 = {
  container: container$1,
  visible,
  bar
};
function AutoplayProgress({
  emblaApi
}) {
  const ref = useRef(null);
  const {
    visible: visible2
  } = useAutoplayProgress(emblaApi, ref);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    className: clsx(classes$2.container, visible2 && classes$2.visible),
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: classes$2.bar,
      ref
    })
  });
}
function useAutoplayProgress(emblaApi, progressNode) {
  const [visible2, setVisible] = useState(false);
  const animationName = useRef("");
  const timeoutId = useRef(0);
  const rafId = useRef(0);
  const startProgress = useCallback((timeUntilNext) => {
    const node = progressNode.current;
    if (!node) {
      return;
    }
    if (timeUntilNext === null) {
      return;
    }
    setVisible(true);
    if (!animationName.current) {
      const style = window.getComputedStyle(node);
      animationName.current = style.animationName;
    }
    node.style.animationName = "none";
    node.style.transform = "translate3d(0,0,0)";
    rafId.current = window.requestAnimationFrame(() => {
      timeoutId.current = window.setTimeout(() => {
        node.style.animationName = animationName.current;
        node.style.animationDuration = `${timeUntilNext}ms`;
      }, 0);
    });
  }, [progressNode]);
  useEffect(() => {
    var _a;
    const autoplay = (_a = emblaApi == null ? void 0 : emblaApi.plugins()) == null ? void 0 : _a.autoplay;
    if (!autoplay) {
      return;
    }
    startProgress(autoplay == null ? void 0 : autoplay.timeUntilNext());
    const onTimerSet = () => startProgress(autoplay == null ? void 0 : autoplay.timeUntilNext());
    const onTimerStopped = () => setVisible(false);
    emblaApi.on("autoplay:timerset", onTimerSet).on("autoplay:timerstopped", onTimerStopped);
    return () => {
      emblaApi.off("autoplay:timerset", onTimerSet).off("autoplay:timerstopped", onTimerStopped);
    };
  }, [emblaApi, startProgress, progressNode]);
  useEffect(() => {
    return () => {
      cancelAnimationFrame(rafId.current);
      clearTimeout(timeoutId.current);
    };
  }, []);
  return {
    visible: visible2
  };
}
const list = "sb-banners-list__ivxBi";
const placeholder = "sb-banners-placeholder__fnWA1";
const classes$1 = {
  list,
  placeholder
};
function ListNavigation({
  currentSlide,
  emblaApi,
  banners
}) {
  if (banners == null) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      className: classes$1.placeholder,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, {
        height: 34,
        width: 140,
        theme: "light"
      }), /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, {
        height: 34,
        width: 240,
        theme: "light"
      }), /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, {
        height: 34,
        width: 160,
        theme: "light"
      }), /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, {
        height: 34,
        width: 200,
        theme: "light"
      }), /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, {
        height: 34,
        width: 140,
        theme: "light"
      })]
    });
  }
  if (banners.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TabsRoot, {
    value: currentSlide.toString(),
    onValueChange: (value) => {
      var _a;
      emblaApi == null ? void 0 : emblaApi.scrollTo(+value);
      (_a = emblaApi == null ? void 0 : emblaApi.plugins()) == null ? void 0 : _a.autoplay.play();
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TabsList, {
      className: classes$1.list,
      variant: "standard",
      theme: "light",
      stretch: false,
      children: banners.map((banner, index) => {
        var _a;
        return /* @__PURE__ */ jsxRuntimeExports.jsx(TabsTrigger, {
          value: index.toString(),
          variant: "standard",
          className: "banners-carousel__link",
          theme: "light",
          children: banner.name
        }, ((_a = banner._metadata) == null ? void 0 : _a.uid) + banner.name);
      })
    })
  });
}
const container = "sb-banners-container__eUZZX";
const button = "sb-banners-button__iMS-l";
const active = "sb-banners-active__eHR-J";
const classes = {
  container,
  button,
  active
};
function DotNavigation({
  banners,
  currentSlide,
  emblaApi
}) {
  if (!banners || banners.length <= 1) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    className: classes.container,
    children: banners.map((banner, index) => {
      var _a;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonClean, {
        onClick: () => {
          var _a2;
          emblaApi == null ? void 0 : emblaApi.scrollTo(index);
          (_a2 = emblaApi == null ? void 0 : emblaApi.plugins()) == null ? void 0 : _a2.autoplay.play();
        },
        className: clsx(classes.button, index === currentSlide && classes.active, "banners-carousel__link")
      }, ((_a = banner._metadata) == null ? void 0 : _a.uid) + banner.name);
    })
  });
}
function useCurrentSlide(emblaApi) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const onSelect = useCallback((emblaApi2) => {
    setCurrentSlide(emblaApi2.selectedScrollSnap());
  }, []);
  useEffect(() => {
    if (!emblaApi) {
      return;
    }
    onSelect(emblaApi);
    emblaApi.on("reInit", onSelect).on("select", onSelect);
    return () => {
      emblaApi.off("reInit", onSelect).off("select", onSelect);
    };
  }, [emblaApi, onSelect]);
  return currentSlide;
}
const carouselConfig = {
  loop: true,
  align: "center",
  skipSnaps: false
};
const carouselPlugins = [Autoplay({
  delay: 7e3,
  stopOnInteraction: false,
  stopOnMouseEnter: true,
  stopOnFocusIn: false
})];
function Banners$1({
  className,
  style,
  contentStackConfig,
  translations = defaultTranslations
}) {
  const [emblaRef, emblaApi] = useCarousel(carouselConfig, carouselPlugins);
  const [banners, setBanners] = useState(void 0);
  useEffect(() => {
    const abortController = new AbortController();
    let intervalId = 0;
    setBanners(void 0);
    fetchBannerEntries({
      baseUrl: contentStackConfig.baseUrl,
      key: contentStackConfig.key,
      apiKey: contentStackConfig.apiKey,
      locale: contentStackConfig.locale,
      deliveryToken: contentStackConfig.deliveryToken,
      environment: contentStackConfig.environment
    }, {
      abortSignal: abortController.signal
    }).then((entries) => {
      if (!abortController.signal.aborted && entries.length > 0) {
        setBanners(filterBanners(entries[0].banners));
        intervalId = window.setInterval(() => {
          setBanners(filterBanners(entries[0].banners));
        }, 1e3);
      } else {
        setBanners([]);
      }
    }).catch((error) => {
      console.warn("Failed fetching banner entries:", error);
      setBanners([]);
    });
    return () => {
      abortController.abort("Component unmounted");
      clearInterval(intervalId);
    };
  }, [contentStackConfig.baseUrl, contentStackConfig.key, contentStackConfig.apiKey, contentStackConfig.locale, contentStackConfig.deliveryToken, contentStackConfig.environment]);
  const currentSlide = useCurrentSlide(emblaApi);
  if ((banners == null ? void 0 : banners.length) === 0) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TranslationsContext.Provider, {
    value: translations,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      className: clsx("sb-banners", classes$7.root, className),
      style,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
        className: classes$7.carousel,
        ref: emblaRef,
        children: [/* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
          className: classes$7.container,
          children: [banners === void 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, {
            width: "100%",
            height: "100%",
            style: {
              borderRadius: 0
            }
          }), banners == null ? void 0 : banners.map((entry, index) => {
            var _a;
            return /* @__PURE__ */ jsxRuntimeExports.jsx(Slide, {
              banner: entry,
              emblaApi,
              visible: index === currentSlide,
              index
            }, ((_a = entry._metadata) == null ? void 0 : _a.uid) + entry.name);
          })]
        }), /* @__PURE__ */ jsxRuntimeExports.jsx(DotNavigation, {
          currentSlide,
          banners,
          emblaApi
        }), /* @__PURE__ */ jsxRuntimeExports.jsx(AutoplayProgress, {
          emblaApi
        })]
      }), /* @__PURE__ */ jsxRuntimeExports.jsx(ListNavigation, {
        currentSlide,
        emblaApi,
        banners
      })]
    })
  });
}
class Banners extends PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      error: null
    });
  }
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  resetState() {
    this.setState({
      error: null
    });
  }
  componentDidCatch(error, errorInfo) {
    console.error('Error while rendering "Banners":', error, errorInfo);
  }
  render() {
    return this.state.error ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(Banners$1, {
      ...this.props
    });
  }
}
export {
  Banners
};
//# sourceMappingURL=index.js.map
